import { ArrowLeft, Compass } from "lucide-react";
import { useNavigate } from "react-router";

import { HeaderText } from "@src/shared/components/general/HeaderText";
import { Text } from "@src/shared/components/general/Text";
import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";
import { Button } from "@src/shared/components/ui/button";
import { navigation } from "@src/shared/navigation";

export const PageNotFoundError = () => {
  const navigate = useNavigate();

  return (
    <VerticalFlexbox
      alignItems="center"
      justifyContent="center"
      gap="md"
      className="min-h-[60vh] w-full px-6 py-12 text-center"
    >
      <VerticalFlexbox
        alignItems="center"
        justifyContent="center"
        className="size-16 rounded-full bg-accent/10 text-accent"
      >
        <Compass className="size-8" />
      </VerticalFlexbox>
      <HeaderText tag="h1" className="text-5xl">
        404
      </HeaderText>
      <Text sizing="sm" appearance="subdued" className="max-w-md">
        The page you&rsquo;re looking for doesn&rsquo;t exist or has been moved.
      </Text>
      <Button
        className="mt-2 bg-accent text-accent-foreground hover:bg-accent/90"
        onClick={() => navigate(navigation.dashboard())}
      >
        <ArrowLeft className="mr-1 size-4" />
        Back to Dashboard
      </Button>
    </VerticalFlexbox>
  );
};
